export default __webpack_public_path__ + "static/media/grafema_ummi_16.47e40271.jpg";